import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Hero } from "@/components/home/Hero";
import { NoCommissions } from "@/components/home/NoCommissions";
import { ProductQuality, HowTestingWorks } from "@/components/home/ProductQuality";
import { SavingsCalculator } from "@/components/home/SavingsCalculator";
import { FarmVideo } from "@/components/home/FarmVideo";
import { HowItWorks } from "@/components/home/HowItWorks";
import { WhyWeVet } from "@/components/home/WhyWeVet";
import { Tiers } from "@/components/home/Tiers";
import { AddOns } from "@/components/home/AddOns";
import { Faq } from "@/components/home/Faq";
import { ContactSection } from "@/components/home/ContactSection";
import { AnnouncementsSection } from "@/components/home/AnnouncementsSection";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [hash]);
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <NoCommissions />
        <SavingsCalculator />
        <ProductQuality />
        <HowTestingWorks />
        <FarmVideo />
        <HowItWorks />
        <WhyWeVet />
        <Tiers />
        <AddOns />
        <AnnouncementsSection />
        <Faq />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
